import { render, staticRenderFns } from "./BetBuilderBadge.vue?vue&type=template&id=6a0ebfe0"
import script from "./BetBuilderBadge.vue?vue&type=script&lang=js"
export * from "./BetBuilderBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports